import React, { useState, useEffect } from 'react';
import { useListadoRecordado } from '../../components/useListadoRecordado';
import axios from '../../axiosConfig';
import { useParams, useNavigate } from 'react-router-dom';
import { Table, Alert, Button, Form, Modal } from 'react-bootstrap';
import moment from 'moment';
import { useLoading } from '../../components/LoadingContext';
import { toast, ToastContainer } from 'react-toastify';
import PaginationTable from '../../components/PaginationTable';
import { ResponsiveContainer,Line, LineChart,BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend,AreaChart,Area,Radar,RadarChart, PieChart, Cell, Pie, ComposedChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis } from 'recharts';
import { FaUserFriends, FaClock, FaBook,FaSync,FaSearch } from 'react-icons/fa';  // Importamos íconos de react-icons
import ProgressBar from 'react-bootstrap/ProgressBar';
import { FaExpand, FaCompress } from 'react-icons/fa'; // Íconos para expandir/contraer
import { motion } from 'framer-motion';




const ShowInscritosIniciativas = () => {
  const { id } = useParams();
  const [inscripciones, setInscripciones] = useState([]);
  const [filteredInscripciones, setFilteredInscripciones] = useState([]);
  const [searchCedula, setSearchCedula] = useState('');
  const [error, setError] = useState('');
  const [cursoCod, setCursoCod] = useState(''); // Estado para guardar el código del curso
  const [patrocinanteName, setPatrocinanteName] = useState(''); // Estado para guardar el código del curso

  const [showModal, setShowModal] = useState(false); // Estado para controlar el modal
  const [selectedId, setSelectedId] = useState(null); // Estado para guardar el ID de la inscripción a eliminar
  const navigate = useNavigate();
  const { setLoading } = useLoading();
  const userRole = localStorage.getItem('role'); // Puede ser 'admin', 'superuser', 'invitado', etc.
  const itemsPerPage = 5; // Número de elementos por página
  const [showCompleteModal, setShowCompleteModal] = useState(false); // Estado para controlar el modal de "culminado"
  const [selectedCompleteId, setSelectedCompleteId] = useState(null); // Estado para guardar el ID de la inscripción a marcar como culminado
  const [range, setRange] = useState(30); // Estado para seleccionar rango de días
  const [loadingData, setLoadingData] = useState(false); // Estado para controlar la recarga
  const [selectedCursoStatus, setSelectedCursoStatus] = useState(''); // Estado para el filtro de estado de curso
  const [showExoneradoModal, setShowExoneradoModal] = useState(false); // Controla el modal de exonerado
  const [selectedExoneradoId, setSelectedExoneradoId] = useState(null); // Guarda el ID de la inscripción a exonerar
  const [showRetiradoModal, setShowRetiradoModal] = useState(false); // Estado para el modal de Retirado
  const [selectedRetiradoId, setSelectedRetiradoId] = useState(null); // Estado para el ID de inscripción
  const [centroOptions, setCentroOptions] = useState([]);
  const [cohorteOptions, setCohorteOptions] = useState([]);
  const [periodoOptions, setPeriodoOptions] = useState([]);
    const [tipoRetiroOptions, setTipoRetiroOptions] = useState([]);
    const [grupoOptions, setGrupoOptions] = useState([]);
    const [iniciativaOptions, setIniciativaOptions] = useState([]);


    const [statistics, setStatistics] = useState({});
    
      const [totalPages, setTotalPages] = useState(1); // Default to 1 page initially
    const [mostrarSoloTabla, setMostrarSoloTabla] = useState(false);
          
              const toggleTablaExpandida = () => {
                  setMostrarSoloTabla(prevState => !prevState);
              };    


    // Página y filtros se recuerdan (por patrocinante): al volver de Editar el listado queda donde estaba.
    const { filters, setFilters, currentPage, setCurrentPage } = useListadoRecordado(`inscritos-iniciativa:${id}`, {
            cedula_identidad: '',
            cohorte: '',
            grupo:'',
            iniciativa_id:'',
            completado:''
        });
        
        const isActiveFilterValue = (v) => {
  if (v === null || v === undefined) return false;
  return String(v).trim() !== "";
};

 const activeFilterClass = (v) => (isActiveFilterValue(v) ? "is-active-filter" : "");

  useEffect(() => {
    setLoading(true);
    Promise.all([fetchFilterOptions(),getInscritos(currentPage),getPatrocinante()]).finally(() => {
      setLoading(false);
    });
  }, [id]);

    // Obtener los detalles del curso por ID
    const getPatrocinante = async () => {
      try {
  
        const token = localStorage.getItem('token');
        // Hacer una solicitud solo para el curso específico
        const response = await axios.get(`/patrocinantes/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
  
        const patrocinante = response.data;
  
        if (patrocinante) {
          setPatrocinanteName(patrocinante.nombre_patrocinante);
        } else {
          setCursoCod('Desconocido');
        }
      } catch (error) {
        console.error('Error fetching patrocinante:', error);
        setError('Error al obtener patrocinante');
      }
    };

 
  const fetchFilterOptions = async () => {
    try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`/filter-inscripciones`, { headers: { Authorization: `Bearer ${token}` } });

        
        setCohorteOptions(response.data.cohorte);
        setPeriodoOptions(response.data.periodo);
        setTipoRetiroOptions(response.data.tipoRetiro);
        setGrupoOptions (response.data.grupo);
        setIniciativaOptions (response.data.iniciativa);



    } catch (error) {
        setError('Error fetching filter options');
        console.error('Error fetching filter options:', error);
    }
};

const getInscritos = async (page = 1) => {
  // Buscar pasa el evento del clic como `page`: cualquier cosa que no sea
  // un número es la página 1. Y la página mostrada se fija aquí, así
  // coincide siempre con los datos (buscar, recargar, borrar, paginar).
  const pagina = Number.isInteger(page) && page > 0 ? page : 1;
  setCurrentPage(pagina);
  try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`/insc-iniciativas-filtros/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { ...filters, page: pagina },
      });
      const estadisticas = response.data.estadisticas || {};
      setInscripciones(Array.isArray(response.data.datos.data) ? response.data.datos.data : []);
      setStatistics(estadisticas);
      setTotalPages(response.data.datos.last_page || 1); // Actualiza el total de páginas
      // Si la página quedó vacía (se borró el último registro de la última
      // página), se muestra la última que exista en vez de una tabla vacía.
      if (pagina > (response.data.datos.last_page || 1)) {
        getInscritos(response.data.datos.last_page || 1);
        return;
      }
  } catch (error) {
      console.error('Error fetching data:', error);
      toast.error('Error fetching data');
      setInscripciones([]);
      setStatistics({});
  }
};



  const getStatusPayColor = (status) => {
    if (status === false) return 'red'; // No pagado
    if (status === true) return 'green'; // Pagado


    return 'gray'; // Desconocido
  };


// Mostrar el modal de confirmación para marcar como culminado
const handleShowCompleteModal = (id) => {
  setSelectedCompleteId(id);
  setShowCompleteModal(true);
};

// Cerrar el modal de culminado
const handleCloseCompleteModal = () => {
  setShowCompleteModal(false);
};


  //
const handleMarkAsComplete = async () => {
  try {
    const token = localStorage.getItem('token');
    await axios.put(`/insc-iniciativa/${selectedCompleteId}`, {
      completado: true,
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    toast.success('El participante ha sido marcado como "Completado"');
    setFilteredInscripciones(
      filteredInscripciones.map(inscripcion =>
        inscripcion.id === selectedCompleteId ? { ...inscripcion, status_curso:true } : inscripcion
      )
    );
    setShowCompleteModal(false); // Cierra el modal tras éxito
    loadData();
  } catch (error) {
    console.error('Error updating status_pay:', error);
    toast.error('Error al marcar como culminado');
    setShowCompleteModal(false);
  }
};

// Función para marcar como retirado
const handleMarkAsRetirado = async () => {
  try {
    const token = localStorage.getItem('token');
    await axios.put(`/insc-iniciativa/${selectedRetiradoId}`, {
      
      completado: false, 
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    toast.success('El participante ha sido marcado como "No Completado"');
    setFilteredInscripciones(
      filteredInscripciones.map(inscripcion =>
        inscripcion.id === selectedRetiradoId ? { ...inscripcion, status_curso: 3 } : inscripcion
      )
    );
    setShowRetiradoModal(false); // Cierra el modal tras éxito
    setFilters(prev => ({ ...prev, tipo_retiro_id: '', obs_retiro: '' }));
    loadData();
  } catch (error) {
    console.error('Error updating status_curso:', error);
    toast.error('Error al marcar como retirado');
    setShowRetiradoModal(false);
  }
};




  const renderStatusPayDot = (status_pay) => {
    const color = getStatusPayColor(status_pay);
    return (
      <div
        style={{
          height: '20px',
          width: '20px',
          borderRadius: '50%',
          backgroundColor: color,
          display: 'inline-block',
        }}
      ></div>
    );
  };


  // Mostrar el modal para confirmar la eliminación
  const handleShowModal = (id) => {
    setSelectedId(id);  // Almacena el ID de la inscripción que se va a eliminar
    setShowModal(true); // Muestra el modal
  };

  const handleCloseModal = () => {
    setShowModal(false); // Cierra el modal
  };

  // Función para abrir el modal
const handleShowRetiradoModal = (id) => {
  setSelectedRetiradoId(id);
  setShowRetiradoModal(true);
};

// Función para cerrar el modal
const handleCloseRetiradoModal = () => {
  setShowRetiradoModal(false);
};

  const handleDelete = async () => {
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`/insc-iniciativa/${selectedId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      toast.success('Éxito al eliminar la inscripción');
      setFilteredInscripciones(filteredInscripciones.filter(inscripcion => inscripcion.id !== selectedId));
      getInscritos(currentPage);
      setShowModal(false); // Cierra el modal tras la eliminación exitosa
    } catch (error) {
      console.error('Error deleting inscripcion:', error);
      setError('Error al eliminar la inscripción');
      setShowModal(false); // Cierra el modal tras el error
    }
  };
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
};

  const handlePageChange = (page) => {
    setCurrentPage(page);
    getInscritos(page);

};

  const loadData = async () => {
    setLoadingData(true); // Inicia el estado de carga
    try {
        await Promise.all([getInscritos(currentPage), fetchFilterOptions()]); // Espera a que getAllDatos haga la solicitud y actualice los datos
    } catch (error) {
        console.error('Error recargando los datos:', error); // Maneja el error si ocurre
    } finally {
        setLoadingData(false); // Detener el estado de carga cuando la solicitud haya terminado
    }
};

const estado = statistics?.estado?.map(({ nombre, cantidad }) => {
  let color;

  if (nombre === "No Completado (Rojo)") color = "red"; // Naranja
  if (nombre === "Completado(Verde)") color = "green"; // Rojo

  return{
  name: nombre,
  value: cantidad, // Clave que PieChart espera para los valores numéricos
  color
  };
});


  const columns = ["Status", "Cédula", "Periodo", "Nombres", "Apellidos","Nivel de Inst","Teléfono","Correo","Iniciativa","Grupo","descripcion", "Acciones Status","Acciones"];

  const renderItem = (inscripcion) => (
    <tr key={inscripcion.id}>

      <td className="text-center">{renderStatusPayDot(inscripcion.completado)}</td>
      <td>{inscripcion?.participantes_fat?.cedula_identidad}</td>
      <td>{inscripcion?.periodo?.descripcion}</td>
      <td>{inscripcion?.participantes_fat?.nombres}</td>
      <td>{inscripcion?.participantes_fat?.apellidos}</td>
      <td>{inscripcion?.participantes_fat?.nivel_instruccion?.descripcion}</td>
      <td>{inscripcion?.participantes_fat?.tlf_casa}</td>
      <td>{inscripcion?.participantes_fat?.email}</td>
      <td>{inscripcion?.iniciativa?.descripcion}</td>
      <td>{inscripcion?.grupo}</td>
      <td>{inscripcion?.descripcion}</td>

      
      <td>


         <div className="d-flex justify-content-center align-items-center" style={{ gap: '5px' }}>
                {/* Botón para marcar como culminado si el rol es 'admin' o 'superuser' y status_pay es 3 */}
                {(userRole === 'admin' || userRole === 'coordinador'   || userRole === 'corporativo'|| userRole === 'servicio-corp')  && (
                  <Button variant="btn btn-success" onClick={() => handleShowCompleteModal(inscripcion.id)} className="me-1" title='Marcar como culminado'>
                    <i className="bi bi-check-circle"></i>
                  </Button>
                )}
                {/*
                Botón Retirado */}
                 {(userRole === 'admin' || userRole === 'coordinador'  || userRole === 'corporativo' || userRole === 'servicio-corp')  && (
                <Button
                  onClick={() => handleShowRetiradoModal(inscripcion.id)}
                  className="me-1"
                  style={{
                    backgroundColor: '#FF4A4A', // Rojo
                    color: 'white',
                    border: 'none',
                    padding: '5px 10px',
                    fontSize: '14px',
                    width: '40px',
                    height: '40px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '5px'
                  }}
                  title='Retirar'
                >
                  <i className="bi bi-x-lg"></i> {/* Icono de "X" */}
                </Button>
                )}
        </div>
        </td>
        <td>


        <div className="d-flex justify-content-center align-items-center" style={{ gap: '5px' }}>


       
      

        {(userRole === 'admin' || userRole === 'coordinador' || userRole === 'corporativo'|| userRole === 'servicio-corp')  && (
          <Button variant="btn btn-warning" onClick={() => navigate(`/insc-iniciativas/edit/${inscripcion.id}/${inscripcion?.participantes_fat?.cedula_identidad}`)} className="me-1" title='Editar'>
            <i className="bi bi-pencil-fill"></i>
          </Button>
        )}
        {/* Botón para eliminar si el rol es 'admin' */}
        {userRole === 'admin' && (
          <Button variant="btn btn-danger" onClick={() => handleShowModal(inscripcion.id)} className="me-1" title='Eliminar'> 
            <i className="bi bi-trash3-fill"></i>
          </Button>
        )}
        </div>
      </td>
    </tr>
  );

  return (
    <div className="container-fluid " style={{ fontSize: '0.85rem' }}>
       <motion.div 
            initial={{ opacity: 1, maxHeight: "500px" }} // Establece una altura máxima inicial
            animate={{
                opacity: mostrarSoloTabla ? 0 : 1,
                maxHeight: mostrarSoloTabla ? 0 : "500px", // Reduce la altura en transición
            }}
            transition={{ duration: 0.5, ease: "easeInOut" }} // Animación más fluida
            style={{ overflow: "hidden" }} // Evita que los elementos internos se muestren fuera de la caja
        >
    <div className="stat-box mx-auto col-lg-11" style={{ maxWidth: '100%' }}>
        {/* Total de Inscritos */}
        <div className="stat-card" style={{  }}>
            <div className="stat-icon" style={{ fontSize: '14px', color: '#333', marginBottom: '1px' }}><FaUserFriends /></div>
            <div className="stat-number" style={{ color: 'rgba(255, 74, 74, 0.9)', fontSize: '1.8rem' }}>
              {statistics?.totalInscritos !== undefined ? statistics.totalInscritos : '0'}
            </div>
            <h4 style={{ fontSize: '1.1rem', color:'gray' }}>Total de Inscritos</h4>

        </div>

        {/* Promedio de Antigüedad */}
        <div className="stat-card" style={{
                    padding: '8px',
                    margin: '0 10px',
                    width: '22%',
                    position: 'relative',
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                }}>

                    {/* Menor y Mayor Edad - Distribuidos a los lados */}
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',  // Distribuye menor a la izquierda y mayor a la derecha
                        fontSize: '0.8rem',  // Ajustamos el tamaño del texto
                        color: '#6c757d',
                        padding: '0 8px',  // Reducimos el padding para que esté más junto
                    }}>
                        <div style={{ color: '#5cb85c', fontWeight: 'bold' }}> {/* Color verde para menor */}
                            <span>↓ Menor:</span> {statistics?.menorEdad != undefined ? statistics?.menorEdad :'0'} años
                            
                        </div>
                        <div style={{ color: '#d9534f', fontWeight: 'bold' }}> {/* Color rojo para mayor */}
                            <span>↑ Mayor:</span> {statistics?.mayorEdad != undefined ? statistics?.mayorEdad :'0'} años
                        </div>
                    </div>
                  {/* Promedio de Edad */}
                    {statistics?.promedioEdad !== undefined && statistics?.promedioEdad !== null && (

                    <div className="stat-number" style={{
                        color: '#ffda1f',
                        fontSize: '1.7rem',  // Reducimos el tamaño de la fuente
                        fontWeight: 'bold',
                        textAlign: 'center',
                        marginBottom: '3px',  // Reducimos el margen
                    }}>
                        {statistics?.promedioEdad?.toFixed(0) || 'N/A'} Años
                    </div>
                    )}
                    <h4 style={{
                        fontSize: '0.9rem',  // Reducimos el tamaño del texto
                        color: '#6c757d',
                        textAlign: 'center',
                        marginBottom: '6px',  // Reducimos el margen inferior
                    }}>
                        Promedio de Edad
                    </h4>

                    {/* Barra de Progreso */}
                    {statistics?.promedioEdad !== undefined &&
                    statistics?.mayorEdad !== undefined &&
                    statistics?.promedioEdad !== null &&
                    statistics?.mayorEdad !== null && (
                    <div style={{ width: '75%', margin: '0 auto' }}>
                        <ProgressBar
                            now={(statistics.promedioEdad * 100) / statistics.mayorEdad}
                            variant="warning"
                            style={{
                                height: '8px',  // Reducimos la altura de la barra
                                borderRadius: '5px',
                                backgroundColor: '#f1f1f1'
                            }}
                        />
                    </div>)}
                </div>
                
    </div>
    </motion.div>

    <div className="row" style={{ marginTop: '10px' }}>
      {/* Columna para la tabla */}
      <div className="col-lg-11 mx-auto"> {/* Agregamos 'mx-auto' para centrar */}
          <div className="card-box" style={{ padding: '20px', width: '100%', margin: '0 auto' }}>
          <div className="d-flex justify-content-between align-items-center mb-3" style={{ gap: '0px' }}>
          <h1>Inscritos en Iniciativas de {patrocinanteName} </h1>
        <div className="d-flex align-items-center justify-content-between"> {/* Alineación horizontal */}
           <Button 
                  variant="info me-2" 
                  onClick={toggleTablaExpandida} 
                  style={{ padding: '5px 15px' }}
                  title={mostrarSoloTabla ? "Mostrar Todo" : "Modo Tabla Expandida"}
              >
                  {mostrarSoloTabla ? <FaCompress /> : <FaExpand />}
              </Button>

          <Form.Control
              type="text"
              placeholder="Buscar por Cédula"
              value={filters.cedula_identidad} // Conecta el campo de cédula al estado de filtros
              name="cedula_identidad"
              onChange={handleFilterChange} // Usa handleFilterChange para actualizar el valor
              className={activeFilterClass(filters.cedula_identidad)}
          />
                  <Button
                  variant="info me-2"
                  onClick={loadData}
                  disabled={loadingData} // Deshabilita el botón si está cargando
                  style={{ padding: '5px 10px', width: '120px' }} // Ajusta padding y ancho
                  title='Recargar datos'
              >
                  {/* Icono de recarga */}
                  {loadingData ? (
                  <FaSync className="spin" /> // Ícono girando si está cargando
                  ) : (
                  <FaSync />
                  )}
              </Button>
              <Button
                  variant="info me-2"
                  onClick={getInscritos}
                  style={{ padding: '5px 10px', width: '120px' }} // Ajusta padding y ancho
                  title='Buscar'
              >
                  <FaSearch className="me-1" /> {/* Ícono de lupa */}
              </Button>
         

          <Button variant="secondary" onClick={() => navigate(-1)} className="secondary" style={{ fontSize: '0.9rem' }} title='Volver'>
            <i className="bi bi-arrow-90deg-left"></i>
          </Button>
        </div>
      </div>

        {/* Alinear el buscador y el filtro en la misma fila con el nuevo botón a la derecha */}
    <div className="d-flex justify-content-between align-items-center mb-3">
      <div className="d-flex align-items-center" style={{ gap: '10px' }}> {/* Ajusta el espacio entre el buscador y el filtro */}

        <Form.Select
            name="iniciativa_id"
            value={filters.iniciativa_id}
            onChange={handleFilterChange}
            className={activeFilterClass(filters.iniciativa_id)}
        >
            <option value="">Iniciativas</option>
            {iniciativaOptions?.map(option => (
                <option key={option.id} value={option.id}>{option.descripcion}</option>
            ))}

        </Form.Select>
       
        <Form.Select
            name="cohorte"
            value={filters.cohorte}
            onChange={handleFilterChange}
            className={activeFilterClass(filters.cohorte)}
        >
            <option value="">Cohorte</option>
            {cohorteOptions?.map(option => (
                <option key={option.id} value={option.descripcion}>{option.descripcion}</option>
            ))}

        </Form.Select>
        <Form.Select
            name="periodo_id"
            value={filters.periodo_id}
            onChange={handleFilterChange}
            className={activeFilterClass(filters.periodo_id)}
        >
            <option value="">Periodo</option>
            {periodoOptions?.map(option => (
                <option key={option.id} value={option.id}>{option.descripcion}</option>
            ))}

        </Form.Select>
        <Form.Select
            name="grupo"
            value={filters.grupo}
            onChange={handleFilterChange}
            className={activeFilterClass(filters.grupo)}
        >
            <option value="">Grupo</option>
            {grupoOptions?.map(option => (
                <option key={option.id} value={option.id}>{option.descripcion}</option>
            ))}

        </Form.Select>
        <Form.Select
          name="completado"
          value={filters.completado}
          onChange={handleFilterChange}
          className={activeFilterClass(filters.completado)}
          style={{ width: 'auto' }}
        >
          <option value="">Status</option>
          <option value='false'>No Completado (Rojo)</option>
          <option value='true'>Completado (Verde)</option>
     
        </Form.Select>
    
        


      </div>


    </div>


      {/* Leyenda de colores */}
      <div className="status-legend d-flex justify-content-start mb-3">
        <span className="status-dot red"></span> No Completado (Rojo)
        <span className="status-dot green ms-3"></span> Completado(Verde)
      
      </div>
   


      {error && <Alert variant="danger">{error}</Alert>}

      {/* Tabla paginada */}


      <PaginationTable
          data={inscripciones}
          itemsPerPage={itemsPerPage}
          columns={columns}
          renderItem={renderItem}
          currentPage={currentPage}
          onPageChange={handlePageChange}
          totalPages={totalPages}  // <--- Añade esta línea si aún no está
      />

      {/* Modal de eliminación */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmar eliminación</Modal.Title>
        </Modal.Header>
        <Modal.Body>¿Estás seguro de que deseas eliminar esta inscripción?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Cancelar
          </Button>
          <Button variant="danger" onClick={handleDelete}>
            Eliminar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal de Curso Completado */}
      <Modal show={showCompleteModal} onHide={handleCloseCompleteModal}>
      <Modal.Header closeButton>
        <Modal.Title>Confirmar finalización de Iniciativa</Modal.Title>
      </Modal.Header>
      <Modal.Body>¿Estás seguro de que este participante ha culminado la Iniciativa?</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCloseCompleteModal}>
          Cancelar
        </Button>
        <Button variant="success" onClick={handleMarkAsComplete}>
          Marcar como culminado
        </Button>
      </Modal.Footer>
    </Modal>
   
      {/* Modal Retirado      */}
      <Modal show={showRetiradoModal} onHide={handleCloseRetiradoModal}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmar Estado</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          
          
          ¿Estás seguro de que deseas marcar este participante como "No Completado"?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseRetiradoModal}>
            Cancelar
          </Button>
          <Button variant="danger" onClick={handleMarkAsRetirado}>
            Marcar como No Completado
          </Button>
        </Modal.Footer>
      </Modal>





      <ToastContainer />
    </div>
     <motion.div 
                initial={{ opacity: 1, height: "auto" }}
                animate={{ opacity: mostrarSoloTabla ? 0 : 1, height: mostrarSoloTabla ? 0 : "auto" }}
                transition={{ duration: 0.5 }}
            >
    <div className="col-lg-12 d-flex justify-content-between flex-wrap" style={{ gap: '20px', marginTop: '10px' }}>
            <div className="chart-box" style={{ flex: '1 1 100%', maxWidth: '100%', marginRight: '10px' }}>
                    <h4 style={{ fontSize: '1.2rem' }}>Participantes por Estado de Pago</h4>
                    {estado!== undefined && (
                    <ResponsiveContainer width="100%" height={400}>
                      <PieChart>
                        <Pie
                          data={estado}
                          dataKey="value"
                          nameKey="name"
                          cx="50%"
                          cy="50%"
                          outerRadius={120}
                          fill="#8884d8"
                          label
                        >
                          {estado.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={entry.color} />
                          ))}
                        </Pie>
                        <Tooltip />
                      </PieChart>
                    </ResponsiveContainer>  
                    )} 
            </div>

            
            
        </div>
        </motion.div>
    </div>
    
    

        </div>
        


    </div>
  );
};

export default ShowInscritosIniciativas;
